import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import useStore from './../store';
var defaultOptions = {
  width: 626,
  height: 436,
  toolbar: 0,
  status: 0,
  resizable: 1
};

var objectToUrlParams = function objectToUrlParams(obj) {
  return Object.keys(obj).map(function (key) {
    return key + '=' + obj[key];
  }).join(',');
};

export var constructShareLink = function constructShareLink(shareHash, defaultRoute) {
  if (shareHash === void 0) {
    shareHash = null;
  }

  if (defaultRoute === void 0) {
    defaultRoute = '';
  } // If hash === default hash, send back only the root url.


  if (!!shareHash) {
    return window.location.origin + window.location.pathname + shareHash;
  } else {
    return window.location.origin + window.location.pathname + defaultRoute;
  }
};
/**
 * Opens a popup window to share a url on facebook
 * @param {string} shareUrl
 */

export var onFacebookShare = function onFacebookShare(shareUrl, options) {
  if (options === void 0) {
    options = {};
  }

  var url = 'https://facebook.com/sharer.php?display=popup&u=' + shareUrl;
  var popupOptions = objectToUrlParams(Object.assign(defaultOptions, options));
  window.open(url, 'sharer', popupOptions);
};
/**
 * Opens a popup window to share a tweet + url on twitter
 * @param {string} shareUrl
 * @param {string} text
 */

export var onTwitterShare = function onTwitterShare(shareUrl, text, options) {
  if (options === void 0) {
    options = {};
  } // console.log('onTwitterShare')


  var url = 'https://twitter.com/intent/tweet?text=' + encodeURI(text) + '%20' + shareUrl;
  var popupOptions = objectToUrlParams(Object.assign(defaultOptions, options));
  window.open(url, 'sharer', popupOptions);
};
export var onMailShare = function onMailShare(shareUrl, subject, body) {
  // console.log('onMailShare')
  var mail = document.createElement('a');
  mail.href = 'mailto:?' + 'subject=' + subject + '&body=' + body + '%0D%0A%0D%0A' + shareUrl;
  mail.target = '_blank';
  mail.click();
  mail.remove();
};

var Share = function Share(_ref) {
  var props = _extends({}, _ref);
};

export default Share;